import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

function Footer() {
  return (
    <footer>
      <Container>
        <Row>
            <Col className='text-center py-3'>
                <span className='text-body-tertiary small'>Copyright &copy; Liberty Trade Corporation</span>
            </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer
